'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StepFour;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Table = require('../../Table');

var _Table2 = _interopRequireDefault(_Table);

var _Column = require('../../Column');

var _Column2 = _interopRequireDefault(_Column);

var _getPreviewDataToImport = require('../helpers/getPreviewDataToImport');

var _getPreviewDataToImport2 = _interopRequireDefault(_getPreviewDataToImport);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function StepFour(props) {
  var schemaFields = props.schemaFields,
      data = props.data,
      fieldsMap = props.fieldsMap,
      attributes = props.attributes;
  var previewData = (0, _getPreviewDataToImport2.default)(data.slice(0, 5), fieldsMap, attributes);
  return _react2.default.createElement(_Table2.default, {
    className: 'rainbow-import-records-flow_table',
    keyField: 'id',
    data: previewData
  }, schemaFields.map(function (field, index) {
    var key = 'column-' + index;
    return _react2.default.createElement(_Column2.default, {
      key: key,
      header: field,
      field: field
    });
  }));
}

StepFour.propTypes = {
  schemaFields: _propTypes2.default.array,
  data: _propTypes2.default.array,
  fieldsMap: _propTypes2.default.object,
  attributes: _propTypes2.default.object
};
StepFour.defaultProps = {
  schemaFields: [],
  data: [],
  fieldsMap: {},
  attributes: {}
};